module.exports = __webpack_public_path__ + "static/media/telephone.296d1373.svg";